/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 11:21:49
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-11 15:02:16
 * @name: 工单管理模块控制器
 * @Description: 工单管理模块控制器
 * @FilePath: \project\src\module\issue\issue.controller.js
 * @Author: desktop
 */
import { Controller, Get, Post, Validator } from "@/nestVue/common";
@Controller('issue')
class issueController {
  constructor() {

  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 售后列表
   */
  @Validator(require('./validator/getList').validator)
  @Get('getList.html')
  getList(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 待审核列表
   */
  @Validator(require('./validator/getNeedVerifyList').validator)
  @Get('getNeedVerifyList.html')
  getNeedVerifyList(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 待处理列表
   */
  @Validator(require('./validator/getTodoList').validator)
  @Get('getTodoList.html')
  getTodoList(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 待确认列表
   */
  @Validator(require('./validator/getEnsureList').validator)
  @Get('getEnsureList.html')
  getEnsureList(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 申报详情
   */
  @Validator(require('./validator/detail').validator)
  @Get('detail.html')
  detail(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 保存费用
   */
  @Validator(require('./validator/issueFee').validator, { toastError: true })
  @Post('issueFee.html', { showLoading: true, toastSuccess: true, successMsg: '保存成功!' })
  issueFee(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 补发配件安排
   */
  @Validator(require('./validator/replacementParts').validator, { toastError: true })
  @Post('replacementParts.html', { showLoading: true, toastSuccess: true, successMsg: '安排成功!' })
  replacementParts(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 发货人填写物流单号
   */
  @Validator(require('./validator/addTransport').validator, { toastError: true })
  @Post('addTransport.html', { showLoading: true, toastSuccess: true, successMsg: '提交成功!' })
  addTransport(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 安排上门人
   */
  @Validator(require('./validator/homeService').validator, { toastError: true })
  @Post('homeService.html', { showLoading: true, toastSuccess: true, successMsg: '安排成功!' })
  homeService(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 确认上门
   */
  @Validator(require('./validator/confirmHomeService').validator)
  @Post('confirmHomeService.html', { showLoading: true, toastSuccess: true, successMsg: '确认成功!' })
  confirmHomeService(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 填写售后服务单
   */
  @Validator(require('./validator/addServiceIssue').validator, { toastError: true })
  @Post('addServiceIssue.html', { showLoading: true, toastSuccess: true, successMsg: '提交成功!' })
  addServiceIssue(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 缴费审批
   */
  @Validator(require('./validator/confirmFee').validator)
  @Post('confirmFee.html', { showLoading: true, toastSuccess: true, successMsg: '确认成功!' })
  confirmFee(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 确认收到零件
   */
  @Validator(require('./validator/confirmParts').validator, { toastError: true })
  @Post('confirmParts.html', { showLoading: true, toastSuccess: true, successMsg: '确认成功!' })
  confirmParts(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 工单详情
   */
  @Validator(require('./validator/getVeifyQuality').validator)
  @Get('getVeifyQuality.html')
  getVeifyQuality(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 通用审批
   */
  @Validator(require('./validator/doApprove').validator, { toastError: true })
  @Post('doApprove.html', { showLoading: true, toastSuccess: true, successMsg: '审批成功!' })
  doApprove(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 提交售后解决方案
   */
  @Validator(require('./validator/setPlan').validator, { toastError: true })
  @Post('setPlan.html', { showLoading: true, toastSuccess: true, successMsg: '提交成功!' })
  setPlan(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 默认内部收件人
   */
  @Get('getDefaultAddress.html')
  getDefaultAddress(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 快递公司列表
   */
  @Validator(require('./validator/getPackageCompanyList').validator)
  @Get('getPackageCompanyList.html')
  getPackageCompanyList(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 查询物流信息
   */
  @Validator(require('./validator/getPackageInfo').validator)
  @Get('getPackageInfo.html')
  getPackageInfo(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 售后经理审批（选择是否需要销售副总审批）
   */
  @Validator(require('./validator/saleManagerVerify').validator)
  @Post('saleManagerVerify.html', { showLoading: true, toastSuccess: true, successMsg: '审批成功!' })
  saleManagerVerify(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 售后经理审批（选择是否需要营销主任审批）
   */
  @Validator(require('./validator/saleServiceManagerVerify').validator)
  @Post('saleServiceManagerVerify.html', { showLoading: true, toastSuccess: true, successMsg: '审批成功!' })
  saleServiceManagerVerify(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 品质审批
   */
  @Validator(require('./validator/qualityVerify').validator, { toastError: true })
  @Post('qualityVerify.html', { showLoading: true, toastSuccess: true, successMsg: '提交成功!' })
  qualityVerify(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 修改处理方案
   */
  @Validator(require('./validator/edit').validator)
  @Post('edit.html', { showLoading: true, toastSuccess: true, successMsg: '修改成功!' })
  edit(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 上门人员历史记录
   */
  @Get('getLastHomeServiceUser.html')
  getLastHomeServiceUser(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 发件人历史记录
   */
  @Get('getReplacementPartsUser.html')
  getReplacementPartsUser(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 发货人修改物流单号
   */
  @Validator(require('./validator/editTransport').validator, { toastError: true })
  @Post('editTransport.html', { showLoading: true, toastSuccess: true, successMsg: '修改成功!' })
  editTransport(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取乐器类别配置
   */
  @Get('getMusical.html')
  getMusical(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 结束审批流程
   */
  @Post('endFlow.html', { showLoading: true, toastSuccess: true, successMsg: '废单成功!' })
  endFlow(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 销售/销售经理打印
   */
  @Get('issue_print.html')
  issuePrint(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 销售副总审批
   */
  @Validator(require('./validator/secondBoss').validator, { toastError: true })
  @Post('second_boss.html', { showLoading: true, toastSuccess: true, successMsg: '审批成功!' })
  secondBoss(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 更新费用
   */
  @Post('editFee.html', { showLoading: true, toastSuccess: true, successMsg: '修改成功!' })
  editFee(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 根据琴号查询ERP产品id相关信息
   */
  @Get('getPianoInfo.html')
  getPianoInfo(ctx) { }
  /**
  * @Auther: 罗耀祖
  * @LastEditors: 罗耀祖
  * @description: 按型号获取ERP产品列表
  */
  @Get('getPianoModels.html')
  getPianoModels(ctx) { }
  /**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 修改钢琴型号和颜色
 */
  @Post('editIssue.html')
  editIssue(ctx) { }
}
export default issueController;